import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils";
/**
 * Textarea component for multi-line text input.
 *
 * UX Notes:
 * - Min height 80px for comfortable multi-line editing
 * - Visible focus ring
 * - Resizable vertical only to prevent horizontal layout shift
 * - Use with visible <label> — never placeholder-only
 */
const Textarea = React.forwardRef(({ className, ...props }, ref) => {
    return (_jsx("textarea", { className: cn("flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2", "text-base transition-colors duration-200", "placeholder:text-muted-foreground", "focus-visible:border-ring focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring", "disabled:cursor-not-allowed disabled:opacity-50", "resize-y", className), ref: ref, ...props }));
});
Textarea.displayName = "Textarea";
export { Textarea };
//# sourceMappingURL=textarea.js.map